import { Group } from "@mantine/core";
import React from "react";
import LeadsQuickNewFilter from "../controller/LeadsQuickNewFilter";
import LeadsJobs from "../controller/LeadsJobs";
import { useLeadsStore } from "../../../../stores/LeadsStore";
import PrmLayoutChanger from "../controller/PrmLayoutChanger";
import ContactsExteriorFilters from "../../lists/components/ContactsExteriorFilters";
import ContactsExteriorFiltersControlled from "../../lists/components/ContactsExteriorFiltersControlled";

const LeadsTableAdditionalToolbar = ({
  apiRef,
  tableFilter,
  setTableFilter,
  loading,
}) => {
  const loadingJobs = useLeadsStore((s) => s.loadingJobs);
  const setLoadingJobs = useLeadsStore((s) => s.setLoadingJobs);
  const screenIsLarge = window.innerWidth > 1800;

  return (
    <Group
      ml={576}
      justify="end"
      gap={24}
      mr={48}
      pos={"relative"}
      style={{ zIndex: 33 }}
      mb={-69}
      h={32}
      wrap="nowrap"
    >
      <LeadsQuickNewFilter
        apiRef={apiRef}
        tableFilter={tableFilter}
        setTableFilter={setTableFilter}
      />

      {/* <ContactsExteriorFilters
        filter={tableFilter}
        setFilter={setTableFilter}
        loading={loading}
        screenIsLarge={screenIsLarge}
        filterKey="prm"
        limit={2}
      /> */}

      <PrmLayoutChanger />

      <Group ml={"auto"} gap={0} justify="end" mr={32}>
        <LeadsJobs loading={loadingJobs} setLoading={setLoadingJobs} />
      </Group>
    </Group>
  );
};

export default LeadsTableAdditionalToolbar;
